import React from "react";
import { useEffect, useState } from "react";
import { useAxios } from "../../../hooks/useAxios";
import { useTranslation } from "react-i18next";
import Modal2 from "../../../components/modalsus2026/ModalSus";

const Newsletter = () => {
    const [t, i18n] = useTranslation("home");
    const [t2] = useTranslation("global");
    const [isModalOpen2, setIsModalOpen2] = useState(false);

    const trackAnalyticsClick = (label) => {
        window.gtag('event', 'click', {
            event_category: 'Sobre Mi',
            event_label: label,
            value: 1
        });
    };

    const openModal2 = () => {


        setIsModalOpen2(true);
    };

    const closeModal2 = () => {
        setIsModalOpen2(false);
    };

    return (
        <div className="_ngcontent-ng-c3910305518 suscribe_About">
            <section aria-label="Suscripción al boletín" class="about-newsletter-cta">
                <div class="about-newsletter-cta__container">
                    <p class="about-newsletter-cta__message"><span
                        class="about-newsletter-cta__message-desktop">{(t2('general.suscribirsel3'))}</span>
                        <span class="about-newsletter-cta__message-mobile">{(t2('general.suscribirsel2'))}</span></p><button type="button"
                                class="about-newsletter-cta__button" onClick={() => {openModal2(); trackAnalyticsClick('Sobre mi - Suscribirse')}}><span
                                    class="about-newsletter-cta__button-desktop">{(t2('general.suscribirsebtn'))}</span><span
                                        class="about-newsletter-cta__button-mobile">{(t2('general.suscribirsebtn2'))}</span></button>
                </div>
            </section>
            <Modal2 isOpen={isModalOpen2} closeModal={closeModal2} />
        </div>
    );
};

export default Newsletter;